import Vue from "vue";
import Vuetify from "vuetify/lib";
import Themes from "@/constants/themes-colors/Themes";
import "@mdi/font/css/materialdesignicons.css";
import "roboto-fontface/css/roboto/roboto-fontface.css";

Vue.use(Vuetify);

export default new Vuetify(Themes.AQTechThemeConfig);
